export const apiUrl = state => state.apiUrl;

export const baseUrl = state => state.baseUrl;




// WEBPACK FOOTER //
// ./src/store/getters.js